<template>
  <div style="background: #f2f2f2; min-height: 100vh">
    <div class="container">
     
      <div class="row">
        <div class="offset-md-2 col-md-8">
          <div class="card" style="margin-top: 5%">
            <div class="card-body">
              <h5 class="card-title">Register as an CONTRACTOR</h5>
              <div v-show="isMain">
                <h6 class="card-subtitle mb-2 text-muted">Corporate Information</h6>
                <div class="row">
                <div class="col-md-12">
                  <div class="row mb-3">
                    <div class="col-sm-4  text-secondary">Corporate Name:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control" maxlength="50"
                        v-model="dataObj.corpName"
                        :class="error.corpName && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4  text-secondary">Building Name:</div>
                    <div class="col-sm-8">
                      <input
                        maxlength="50"
                        type="text"
                        class="form-control"
                        v-model="dataObj.buildingName"
                        :class="error.buildingName && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Block No:</div>
                    <div class="col-sm-8">
                      <input
                        maxlength="10"
                        type="text"
                        class="form-control"
                        v-model="dataObj.blkNo"
                        :class="error.blkNo && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Unit No:</div>
                    <div class="col-sm-8">
                      <input
                        maxlength="10"
                        type="text"
                        class="form-control"
                        v-model="dataObj.unitNo"
                        :class="error.unitNo && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Address:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <textarea
                      maxlength="100"
                  class="form-control"
                  rows="3"
                  v-model="dataObj.address1"
                  :class="error.address1 && 'control-error'"
                />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Address 2:</div>
                    <div class="col-sm-8">
                      <textarea
                      maxlength="100"
                  class="form-control"
                  rows="3"
                  v-model="dataObj.address2"
                  :class="error.address2 && 'control-error'"
                />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Country:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <FormSelect :cssClass="error.countryOid && 'control-error'" :list="countries" value="oid" text="value" :existing="dataObj.countryOid" @change="dataObj.countryOid=$event"/>
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Postal Code:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                        maxlength="8"
                        type="text"
                        class="form-control"
                        v-model="dataObj.postalCode"
                        :class="error.postalCode && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Administrator Name:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                        maxlength="50"
                        type="text"
                        class="form-control"
                        v-model="dataObj.adminContact"
                        :class="error.adminContact && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Designation of Administrator:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                        maxlength="50"
                        type="text"
                        class="form-control"
                        v-model="dataObj.adminDesignation"
                        :class="error.adminDesignation && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Telephone No:<span class="text-danger">*</span></div>
                    <div class="col-sm-4">
                      <input
                        maxlength="8"
                        type="text"
                        class="form-control"
                        v-model="dataObj.telephone"
                        :class="error.telephone && 'control-error'"
                      />
                      </div>
                      <div class="col-sm-1 text-secondary">Ext</div>
                      <div class="col-sm-3">
                        <input
                        maxlength="5"
                        type="text"
                        class="form-control"
                        v-model="dataObj.ext"
                        :class="error.company && 'control-error'"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Fax:</div>
                    <div class="col-sm-8">
                      <input
                      maxlength="8"
                        type="text"
                        class="form-control"
                        v-model="dataObj.fax"
                        :class="error.fax && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Email Address<span class="text-danger">*</span>:</div>
                    <div class="col-sm-8">
                      <input
                      maxlength="50"
                        type="text"
                        class="form-control"
                        v-model="dataObj.corporateEmail"
                        :class="error.corporateEmail && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Mobile Contact No:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                      maxlength="10"
                        type="text"
                        class="form-control"
                        v-model="dataObj.mobileNo"
                        :class="error.mobileNo && 'control-error'"
                      />
                    </div>
                  </div>
                  <hr/>
                    <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Ownership(Contractors Only)<span class="text-danger">*:</span></div>
                    <div class="col-sm-8">
                      <FormSelect :cssClass="error.ownershipOid && 'control-error'" :list="ownerships" value="oid" text="value" :existing="dataObj.ownershipOid" @change="dataObj.ownershipOid=$event"/>
                    </div>
                    <h6 class="card-subtitle mb-2 text-muted">Principal Activities <span class="text-danger">*</span></h6>
                    <div class="row mb-3">
                        <div class="col-sm-1">
                            <input type="checkbox" v-model="principaleActivities.plantConstruction"/>
                        </div>
                        <div class="col-sm-3 text-secondary">
                            Plant Construction
                        </div>
                        <div class="col-sm-1">
                            <input type="checkbox" v-model="principaleActivities.plantMaintenance"/>
                        </div>
                        <div class="col-sm-3 text-secondary">
                            Plant Maintenance
                        </div>
                        <div class="col-sm-1">
                            <input type="checkbox" v-model="principaleActivities.processDesign"/>
                        </div>
                        <div class="col-sm-3 text-secondary">
                            Process Design
                        </div>
                    </div>
                     <div class="row mb-3">
                        <div class="col-sm-1">
                            <input type="checkbox" v-model="principaleActivities.buildingConstruction"/>
                        </div>
                        <div class="col-sm-3 text-secondary">
                            Building Construction
                        </div>
                        <div class="col-sm-1">
                            <input type="checkbox" v-model="principaleActivities.equipmentInstallation"/>
                        </div>
                        <div class="col-sm-3 text-secondary">
                            Equipment Installation
                        </div>
                        <div class="col-sm-1">
                            <input type="checkbox" v-model="principaleActivities.shopFabrication"/>
                        </div>
                        <div class="col-sm-3 text-secondary">
                            Shop Fabrication
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-sm-3 text-secondary">
                            Others, please specify
                        </div>
                        <div class="col-sm-6">
                            <input
                        type="text"
                        class="form-control"
                        :class="error.others && 'control-error'"
                        v-model="principaleActivities.others"
                      />
                        </div>
                    </div>
                    <h6 class="card-subtitle mb-2 text-muted">Role of Contractor(Contactors only) 1 or more selections:</h6>
                     <div class="row mb-3">
                        <div class="col-sm-1">
                            <input type="checkbox" v-model="roleOfContractor.turnkeyContractor"/>
                        </div>
                        <div class="col-sm-3 text-secondary">
                            Turnkey Contractor
                        </div>
                        <div class="col-sm-1 text-secondary">
                            <input type="checkbox" v-model="roleOfContractor.mainContractor"/>
                        </div>
                        <div class="col-sm-3 text-secondary">
                            Main Contractor 
                        </div>
                        <div class="col-sm-1">
                            <input type="checkbox" v-model="roleOfContractor.subContractor"/>
                        </div>
                        <div class="col-sm-3 text-secondary">
                            Sub Contractor  
                        </div>
                    </div>
                    <h6 class="card-subtitle mb-2 text-muted">Employment Strength (Contractors Only)</h6>
                    <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Total company strength<span class="text-danger">*</span>:</div>
                    <div class="col-sm-8">
                      <input
                        type="number"
                        class="form-control"
                        v-model="dataObj.companyStrength"
                        :class="error.companyStrength && 'control-error'"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">No. of management staff:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                        type="number"
                        class="form-control"
                        v-model="dataObj.managementStaff"
                        :class="error.managementStaff && 'control-error'"
                      />
                    </div>
                  </div>
                  <div class="row mb-3 text-secondary">
                    <div class="col-sm-4">No. of foreigner:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                        type="number"
                        class="form-control"
                        v-model="dataObj.foreignerWorker"
                        :class="error.foreignerWorker && 'control-error'"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">No. of local:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                        type="number"
                        class="form-control"
                        v-model="dataObj.localWorker"
                        :class="error.localWorker && 'control-error'"
                      />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Training budget(%)<span class="text-danger">*</span>:</div>
                    <div class="col-sm-8">
                      <input
                        type="number"
                        class="form-control"
                        v-model="dataObj.trainingBudget"
                        :class="error.trainingBudget && 'control-error'"
                      /> 
                    </div>
                  </div>
                  </div>
                  <hr/>
                  <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">CPF Account No.:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                        type="text"
                        class="form-control"
                        v-model="dataObj.cpfAccountNo"
                        :class="error.cpfAccountNo && 'control-error'"
                         maxlength="20" 
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">SWS Member Name:</div> 
                    <div class="col-sm-8">
                      <v-select label="company" :class="error.swsoid && 'control-error'" v-model="selectedSws" :options="swss" @input="$event==null?null:dataObj.swsoid = $event.oid"></v-select>
                    </div>
                  </div>
                   <!-- <div class="row mb-3">
                    <div class="col-sm-4">ASPRI Member Name:</div>
                    <div class="col-sm-8">
                      <FormSelect :list="parents" value="oid" text="name" :existing="dataObj.parentSettingOid" @change="dataObj.parentSettingOid=$event"/>
                    </div>
                  </div> -->
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Payment Method:</div>
                    <div class="col-sm-8">
                      <FormSelect :cssClass="error.paymentMethodOid && 'control-error'" :list="payments" value="oid" text="value" :existing="dataObj.paymentMethodOid" @change="changePayment"/>
                    </div>
                  </div>
                  <hr/>
                  <div v-show="isGIRO">
                    <h6 class="card-subtitle mb-2 text-muted" >GIRO Information</h6>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Name of Financial Institution:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <FormSelect :cssClass="error.bankOid && 'control-error'" :list="banks" value="oid" text="value" :existing="dataObj.giroTemp.bankOid" @change="changeBank"/>
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Branch:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <FormSelect :cssClass="error.branchCodeOid && 'control-error'" :list="branches" value="oid" text="value" :existing="dataObj.giroTemp.branchCodeOid" @change="dataObj.giroTemp.branchCodeOid=$event"/>
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Account Number:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                      maxlength="11"
                        type="text"
                        class="form-control"
                        v-model="dataObj.giroTemp.bankAccountNum"
                        :class="error.bankAccountNum && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Account Holder Name:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                      maxlength="50"
                        type="text"
                        class="form-control"
                        v-model="dataObj.giroTemp.name"
                        :class="error.gironame && 'control-error'"
                      />
                    </div>
                  </div>
                   <div class="row mb-3">
                    <div class="col-sm-4 text-secondary">Account Holder Contact (Tel/Fax) Number:<span class="text-danger">*</span></div>
                    <div class="col-sm-8">
                      <input
                      maxlength="10"
                        type="text"
                        class="form-control"
                        v-model="dataObj.giroTemp.telephone"
                        :class="error.girotelephone && 'control-error'"
                      />
                    </div>
                  </div>
                  </div>
                  <div class="row mb-3">
                      <div class="col-sm-12">
                        <input type="checkbox" v-model="checkAgreement" @change="chkAgreeChange" /> I have read and agree with the <a href="javascript:;" @click="downloadFile">Terms and Conditions</a> 
                      </div>
                      <div class="col-sm-12">
                        <span class="text-danger">* Denotes Mandatory Field</span>
                      </div>
                  </div>
                </div>
                </div>
                <button class="btn btn-secondary m-1 float-end" @click="clickCancel">
                    Cancel
                </button>
                <button class="btn btn-success m-1 float-end" @click="clickSave">
                    Submit
                </button>
              </div>
              <div v-show="!isMain">
                  <p>PRiMOS Application Confirmation<br></p>
                  
                
                <p></p>
                <div class="row mb-3">
                    <div class="col-sm-4">
                         <button class="btn btn-success" style="width:100%;" @click="clickAgree">Agree</button>
                    </div>
                    <div class="col-sm-4">
                         <button class="btn btn-secondary " style="width:100%;" @click="clickDisagree">Disagree</button>
                    </div>
                    <div class="col-sm-4">
                        <button class="btn btn-secondary" style="width:100%;" @click="clickBack">Back</button>
                    </div>
                </div>
                <p>
      Note:<br>
      
      * Please send all the application form to the following address: <br>
        iMOS Holdings Pte Ltd<br>
        21 Bukit Batok Crescent<br>
        #16-79 WCEGA Tower<br>
        Singapore 658065<br>
        Tel: (65) 6779 7706<br>
        Fax: (65) 6274 4055<br>
        Email: <a href="mailto:info@imos.com.sg">info@imos.com.sg</a><br>
      </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/common/api";
import apiUrl from "@/common/apiurl";
import * as Forms from "@/components/custom/forms";
export default {
  name: "RegisterContractor",
  components: {
    ...Forms,
  },
  data() {
    return {
      selectedSws: {},
      errMessage:"",
      error: {},
      isMain:true,
      isGIRO:false,
      countries:[],
      swss:[],
      payments:[],
      banks:[],
      branches:[],
      ownerships:[],
      checkAgreement:false,
      showModal: false,
      dataObj: {
        giroTemp:{
        }
      },
      principaleActivities:{
          plantConstruction:false,
          plantMaintenance:false,
          processDesign:false,
          buildingConstruction:false,
          equipmentInstallation:false,
          shopFabrication:false,
          others:""
      },
      roleOfContractor:{
          turnkeyContractor:false,
          mainContractor:false,
          subContractor:false
      },
      
    };
  },
  mounted() {
    this.getDropdowns();
  },
  methods: {
    downloadFile() {
      api.downloadFile(apiUrl.corporate.downloadTAC, null, 'PRiMOS_TAC.pdf', () => {
        this.showMessage('Downloaded successfully.', 'success');
      });
    },
    submit() {},
    modal() {
      this.showModal = true;
    },
    chkAgreeChange(e){
      this.chkAgreeChange = e;
    },
    changeBank(e){
      this.dataObj.giroTemp.bankOid = e;
      let url = apiUrl.settings.getByParentOid + "/" + e
      api.regularGet(url, null).then((response) => {
        this.branches = response.data;
      });
    },
    changePayment(e){
      this.dataObj.paymentMethodOid = e;
      if(this.dataObj.paymentMethodOid == this.$data._defaultValue.payment_giro){
        this.isGIRO = true;
      }else{
        this.isGIRO = false;
      }
    },
    getDropdowns() {
      let url = apiUrl.regIndustry.dropdowns
      api.regularGet(url, null).then((response) => {
        let dropdowns = response.data;
        this.countries = dropdowns.countries;
        this.swss = dropdowns.sws;
        this.payments = dropdowns.payments;
        this.banks = dropdowns.banks;
        this.ownerships = dropdowns.ownerships;

        this.dataObj.countryOid = this.$data._defaultValue.countrySingapore;
      });
    },
    clickSave() {
      if (this.validate()) {
        this.isMain = false;
       
      }else{
           if(this.errMessage)
            this.showMessage(this.errMessage, "warning");
           return;
      }
      
    },
    clickAgree(){
        this.dataObj.type = 'C';
        this.dataObj.registerType = "contractor";
        this.dataObj.principalActivities = JSON.stringify(this.principaleActivities);
        this.dataObj.roleOfContractor = JSON.stringify(this.roleOfContractor);
      let subUrl = apiUrl.regIndustry.insert;
      api.regularPost(subUrl, this.dataObj).then((response) => {
        if (response.status == 200) {
          this.showMessage("Successfully saved.", "success");
          this.$router.push({ name: 'CompleteRegister', query: { id: response.data.data.oid } });
        } else if (
          response.status == 400 ||
          response.errorText.response.status == 400
        ) {
          this.showMessage(response.errorText.response.data.message, "error");
        } else {
          this.showMessage(window.message.unable_proceed, "error");
        }
      });
    },
    clickDisagree(){
        let warningMessage = 'INDUSTRY participating in PRiMOS must be member of ASPRI and/or SWS. Please refer to ASPRI Secretariat @64730458 and/or SWS Secretariat @62704730 should you requires assistance.';
      this.showConfirmDiaglog(
        {
          show: true,
          message: warningMessage,
          submitFunction: () => {
            this.$router.push({ name: "RegisterMain" });
          }
        });
    },
    clickBack(){
        this.isMain = true;
    },
    clickCancel() {
      this.$router.push({ name: "RegisterMain" });
    },
    validate() {
      let isValid = true;
      this.errMessage = ""; 
      Object.keys(this.error).forEach(k => this.error[k] = false);
      if (!this.dataObj.corpName){
        this.error.corpName = true; 
        isValid = false;
      }
      if (!this.dataObj.address1){
        this.error.address1 = true; 
        isValid = false;
      }
      if (!this.dataObj.countryOid){
        this.error.countryOid = true; 
        isValid = false;
      }
      if (!this.dataObj.paymentMethodOid){
        this.error.paymentMethodOid = true; 
        isValid = false;
      }else{
        if(this.dataObj.paymentMethodOid == this.$data._defaultValue.payment_giro){
          if (!this.dataObj.giroTemp.bankOid){
            this.error.bankOid = true; 
            isValid = false;
          }
          if (!this.dataObj.giroTemp.bankAccountNum){
            this.error.bankAccountNum = true; 
            isValid = false;
          }
          if (!this.dataObj.giroTemp.name){
            this.error.gironame = true; 
            isValid = false;
          }
          if (!this.dataObj.giroTemp.telephone){
            this.error.girotelephone = true; 
            isValid = false;
          }
        }
      }
      if (!this.dataObj.postalCode){
        this.error.postalCode = true; 
        isValid = false;
      }
      if (!this.dataObj.adminContact){
        this.error.adminContact = true; 
        isValid = false;
      }
      if (!this.dataObj.adminDesignation){
        this.error.adminDesignation = true; 
        isValid = false;
      }
      if (!this.dataObj.telephone){
        this.error.telephone = true; 
        isValid = false;
      }
      if (!this.dataObj.corporateEmail){
        this.error.corporateEmail = true; 
        isValid = false;
      }
      if (!this.dataObj.ownershipOid){
        this.error.ownershipOid = true; 
        isValid = false;
      }
      if (!this.dataObj.cpfAccountNo){
        this.error.cpfAccountNo = true; 
        isValid = false;
      }
      if(!this.principaleActivities.plantConstruction && !this.principaleActivities.plantMaintenance && !this.principaleActivities.processDesign &&
        !this.principaleActivities.buildingConstruction && !this.principaleActivities.equipmentInstallation &&
        !this.principaleActivities.shopFabrication && !this.principaleActivities.others){
            this.errMessage += window.message.coroprateregister.principal_blank + "<br/>";
            isValid = false;
        }
      if(!this.roleOfContractor.turnkeyContractor && !this.roleOfContractor.mainContractor && !this.roleOfContractor.subContractor){
          this.errMessage += window.message.coroprateregister.roleOfContractor_blank+ "<br/>";
          isValid = false;
      }
      if(!this.dataObj.companyStrength){
          this.error.companyStrength = true; 
          isValid = false;
      }
      
      if(!this.dataObj.managementStaff){
          this.error.managementStaff = true; 
        isValid = false;
      }
      if(!this.dataObj.foreignerWorker){
          this.error.foreignerWorker = true; 
        isValid = false;
      }
      if(!this.dataObj.localWorker){
          this.error.localWorker = true; 
        isValid = false;
      }
      if(parseInt(this.dataObj.companyStrength) != (parseInt(this.dataObj.managementStaff) + parseInt(this.dataObj.foreignerWorker) + parseInt(this.dataObj.localWorker))){
        this.errMessage += "Total company strength does not match.<br/>";
        this.error.companyStrength = true; 
        isValid = false;
      }
      if(!this.dataObj.trainingBudget){
          this.error.trainingBudget = true; 
        isValid = false;
      }
      if(!this.dataObj.mobileNo){
        this.error.mobileNo = true; 
        isValid = false;
      }
      if(!this.checkAgreement){
        this.errMessage += "Please accept Terms and Conditions"+ "<br/>";
        isValid = false;
      }
      this.$forceUpdate();  
      return isValid;
    },
  },
};
</script>
